module.exports = 'mutation RemoveFavorite($id:ID!,$context:OpportunityContextInput!){removeFavorite(id:$id,context:$context){id}}'